<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import router from "../../router";
import EventBus from "@/eventBus";
import accessible from '@/mixins/accessible'

export default {
  name: "TransferOrder",
  components: {
    Pagination,
    ErrorComponent,
    Alert
  },
  data() {
    return {
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      sourcestoreList: [],
      destinationstoreList: [],
      currentSorting: "",
      filterObj: {
        destination_store: "",
        source_store: "",
        transfer_status: "",
        sort_by: "",
        order_by: ""
      },
      currentId: null
    };
  },

  mixins: [accessible],

  methods: {
    pageChange(page) {
      this.getList(page, true);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1, true);
    },
    getList(page, flag, sortBy, orderBy) {
      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      if (
        flag &&
        this.filterObj.source_store &&
        this.filterObj.source_store == this.filterObj.destination_store
      ) {
        this.$notify({
          group: "foo",
          text: this.$lang.messages.destination_store_can_not_be_the_same_as_source_store,
          type: "error"
        });
        this.filterObj.destination_store = "";
        return false;
      }
      this.list = [];
      this.currentPage = page;

      this.$api
        .getAPI({
          _action: "/transfer-order/list/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(this.$lang.messages.no_transfer_orders_found);
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.sourcestoreList = res.list;
            this.destinationstoreList = res.list;
          }
        })
        .catch(e => {});
    },

    retry() {
      this.getList(1, true);
    },

    view(id) {
      router.push("/view-transfer-order/" + id);
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";
      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, true, sortBy, orderBy);
    }
  },
  mounted() {
    this.getStoreList();
    this.getList(1, false);

    // get current user profile
    EventBus.$on("GET_ME_SUCCESS", payload => {
      this.currentUser = payload
    });
  }
};
</script>

<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="mb-3 text-lg-right text-center">
              <div
                class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-md-1 mb-3 mb-lg-0 w-xs-100"
                style="width: 160px;">
                <select
                  class="form-control"
                  v-model="filterObj.transfer_status"
                  @change="getList(1, true)">
                  <option value>{{$lang.messages.all_status}}</option>
                  <option value="TRANSIT">{{$lang.messages.TRANSIT}}</option>
                  <option value="TRANSFERRED">{{$lang.messages.TRANSFERRED}}</option>
                </select>
              </div>

              <div
                class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
                style="width: 160px;">
                <select
                  v-model="filterObj.source_store"
                  name="source_store_id"
                  class="form-control"
                  @change="getList(1, true)">
                  <option value>{{$lang.messages.source_store}}</option>
                  <option v-for="obj in sourcestoreList" :key="obj.id" :value="obj.id">{{obj.name}}</option>
                </select>
              </div>

              <div
                class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
                style="width: 160px;">
                <select
                  v-model="filterObj.destination_store"
                  name="destination_store_id"
                  class="form-control"
                  @change="getList(1, true)"
                >
                  <option value>{{$lang.messages.destination_store}}</option>
                  <option
                    v-for="obj in destinationstoreList"
                    :key="obj.id"
                    :value="obj.id"
                  >{{obj.name}}</option>
                </select>
              </div>
              <button
                @click="checkPendingAccountStatus($event, 'add-transfer-order')"
                class="btn btn-primary px-4"
              >+ {{$lang.messages.add_transfer_orders}}</button>
            </div>

            <div class="card rounded-5">
              <div class="card-body table-responsive">
                <table class="table table-striped table-style-1">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th scope="col">{{$lang.messages.transfer_order}} #</th>
                      <th scope="col">{{$lang.messages.date}}</th>
                      <th scope="col">{{$lang.messages.received}}</th>
                      <th scope="col">{{$lang.messages.source_store}}</th>
                      <th scope="col">{{$lang.messages.destination_store}}</th>
                      <th scope="col">{{$lang.messages.status}}</th>
                      <th scope="col" class="text-center">{{$lang.messages.quantity}}</th>
                      <th scope="col" width="20"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(obj,i) in list" :key="obj.id">
                      <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                      <td>{{obj.to_number}}</td>
                      <td>{{obj.transfer_date | moment("DD MMM YYYY") }}</td>
                      <td v-if="obj.received_date">{{obj.received_date | moment("DD MMM YYYY") }}</td>
                      <td v-else>-</td>
                      <td>{{obj.source_store_name}}</td>
                      <td>{{obj.destination_store_name}}</td>
                      <td>
                        <span class="text-info">{{$lang.messages[obj.transfer_status.toUpperCase()]}}</span>
                      </td>
                      <td class="text-center">{{obj.quantity}}</td>
                      <td>
                        <a
                          @click="view(obj.id)"
                          href="javascript:void(0)"
                          class="text-primary mr-2 font-18"
                        >
                          <i class="mdi mdi-pencil"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
